import {Option} from "ts-option";
import {ColumnDefinition} from "./ColumnDefinition";

export class ViewColumn {
	constructor(
		public readonly id: string,
		public readonly columnDefinition: ColumnDefinition,
		public readonly visible: boolean,
		public readonly width: Option<number>) {}


	copy({id = this.id, visible = this.visible, width = this.width}) {
		return new ViewColumn(this.id, this.columnDefinition, visible, width);
	}
}
